<template>
  <div class="survey" v-loading="loading">
    <div v-if="!showMsg">
      <div class="survey-header">
        <div>Welcome to the TP-Link customer satisfaction survey. We appreciate your valued feedback.</div>
      </div>
      <div class="survey-body">
        <template v-if="!isWxkf" >
          <div class="question-item" v-for="(line, index) in lines" :key="line.lineId" >
            <div class="question-title">
              <span class="question-num">{{index+1}}</span>{{line.question}}
            </div>
            <div class="answer">
              <el-radio-group class="horizontal-radio-group" v-model="answerModel[index]">
                <template v-if="line.questionType === 'POINT'">
                  <el-radio label="1 Star"></el-radio>
                  <el-radio label="2 Stars"></el-radio>
                  <el-radio label="3 Stars"></el-radio>
                  <el-radio label="4 Stars"></el-radio>
                  <el-radio label="5 Stars"></el-radio>
                </template>
                <template v-else-if="line.questionType === 'POINT_TEN'">
                  <el-radio label="1"></el-radio>
                  <el-radio label="2"></el-radio>
                  <el-radio label="3"></el-radio>
                  <el-radio label="4"></el-radio>
                  <el-radio label="5"></el-radio>
                  <el-radio label="6"></el-radio>
                  <el-radio label="7"></el-radio>
                  <el-radio label="8"></el-radio>
                  <el-radio label="9"></el-radio>
                  <el-radio label="10"></el-radio>
                </template>
                <template v-else>
                  <el-radio label="Yes"></el-radio>
                  <el-radio label="No"></el-radio>
                </template>
              </el-radio-group>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="question-item" v-for="(line, index) in lines" :key="line.lineId" >
            <div class="question-title">
              <span class="question-num">{{index+1}}</span>{{line.question}}
            </div>
            <div class="answer">
              <el-radio-group v-if="index===0" v-model="answerModel[index]" @change="onFirstQuestionChange">
                <el-radio label="5 Stars"></el-radio>
                <el-radio label="4 Stars"></el-radio>
                <el-radio label="3 Stars"></el-radio>
                <el-radio label="2 Stars"></el-radio>
                <el-radio label="1 Star"></el-radio>
              </el-radio-group>
              <el-radio-group v-else v-model="answerModel[index]">
                <template v-if="line.questionType === 'POINT'">
                  <el-radio label="5 Stars"></el-radio>
                  <el-radio label="4 Stars"></el-radio>
                  <el-radio label="3 Stars"></el-radio>
                  <el-radio label="2 Stars"></el-radio>
                  <el-radio label="1 Star"></el-radio>
                </template>
                <template v-else>
                  <el-radio label="Yes"></el-radio>
                  <el-radio label="No"></el-radio>
                </template>
              </el-radio-group>
            </div>
        </div>
        </template>
        <div class="suggestion">
          <div class="question-title">
            <span class="question-num">{{lines.length + 1}}</span>Please leave your comments here:
          </div>
          <el-input type="textarea" v-model="suggestion" class="suggestion-text" resize="none" :autosize="{minRows: 5, maxRows: 5}"></el-input>
        </div>
        <el-button class="submit-btn" size="mini" @click="submit" v-clipboard:copy="suggestion">Submit</el-button>
      </div>
    </div>
    <div v-else class="msg">
      <img v-if="msgType === 'completed' " src="@/assets/success.png"/>
      <img v-else-if="msgType === 'expired'" src="@/assets/warn.png"/>
      <img v-else-if="msgType === 'data'" src="@/assets/error.png"/>
      <div v-if="!amzLink" class="msg-txt">{{msg}}</div>
      <div v-else class="amz-link">
        <div class="amz-link-title">
          Thanks so much for your review! Would you mind sharing your review on Amazon to help others?
        </div>
        <div class="amz-link-body">
          <div class="amz-link-item">
            1.Your review has already been copied to your clipboard.
          </div>
          <div class="amz-link-item">
            2.Click the button below and paste your review onto Amazon.
          </div>
        </div>
        <el-button class="submit-btn" size="mini" @click="amzlinkclicked"><a :href="amzLink">Publish to Amazon</a></el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import fetch from '@/util/fetch';
import qs from 'qs';
import VueClipboard from 'vue-clipboard2';
import { MessageBox } from 'element-ui';

Vue.use(VueClipboard);

export default {
  name: 'home',
  data () {
    return {
      loading: false,
      headerId: '',
      header: {},
      lines: [],
      allLines: [],
      isSingleQuestion: true,
      showMsg: false,
      msg: '',
      msgType: '',
      answerModel: {},
      suggestion: '',
      amzLink: '',
      isWxkf: false
    };
  },

  mounted () {
    this.headerId = this.$route.query.headerId;
    this.fetchData();
  },

  methods: {
    onFirstQuestionChange (val) {
      if (val === '5 Stars' || val === '4 Stars') {
        this.lines = [this.allLines[0]];
        this.isSingleQuestion = true;
      } else {
        this.lines = this.allLines;
        this.isSingleQuestion = false;
      }
    },

    // 对问题进行排序，让Q5排第一个
    onChangeQuestionOrder () {
      const lineToAdd = this.allLines.find(line => line.displayOrder === 'Q5');
      if (lineToAdd) {
        this.lines.push(lineToAdd);
      }
      for (let i = 0; i < this.allLines.length; i++) {
        let line = this.allLines[i];
        if (line.displayOrder !== 'Q5') {
          this.lines.push(line);
        }
      }
      return this.lines;
    },

    fetchData () {
      if (!this.headerId) {
        this.showMsg = true;
        this.msg = 'Sorry, the page data is missing';
        return;
      }
      this.loading = true;
      // fetch.post('/api/WXKF/SD_SURVEYHOME', qs.stringify({ headerId: this.headerId })).then((res) => {
      fetch.post('/api/order/sd_surveyHomePage.htm', qs.stringify({ headerId: this.headerId })).then((res) => {
        if (res.data.toString().indexOf('failure:true') !== -1) {
          this.showMsg = true;
          this.msg = 'Sorry, this page data is error';
          return;
        }
        this.msg = res.data.homeData.errorMsg;
        this.msgType = res.data.homeData.errorType;
        if (this.msg) {
          this.showMsg = true;
          return;
        }
        this.header = res.data.homeData.header;
        this.allLines = res.data.homeData.lines;
        // 有orderId说明是wxkf，否则是ticket
        this.isWxkf = !!res.data.homeData.header.orderId;
        if (!this.isWxkf) {
          // 对问题进行排序
          this.lines = this.onChangeQuestionOrder();
        } else {
          // 默认显示第一条问题和建议
          this.lines = [res.data.homeData.lines[0]];
        }
      }).catch(() => { }).then(() => {
        this.loading = false;
      });
    },

    amzlinkclicked () {
      const params = {
        headerId: this.header.headerId
      };
      // fetch.post('/api/WXKF/SD_AMZLINKCLICKED', qs.stringify(params));
      fetch.post('/api/order/sd_amzlinkclicked.htm', qs.stringify(params));
    },

    submit () {
      if (this.checkAnswer()) {
        return;
      }
      this.loading = true;
      const params = {
        linesStr: JSON.stringify(this.lines),
        headerId: this.header.headerId,
        suggestion: this.suggestion
      };
      // fetch.post('/api/WXKF/SD_SAVESURVEYDATA', qs.stringify(params)).then((res) => {
      fetch.post('/api/order/sd_saveSurveyData.htm', qs.stringify(params)).then((res) => {
        this.loading = false;
        this.showMsg = true;
        this.msgType = 'completed';
        this.msg = 'We have received your valuable feedback. Thank you for your time.';
        this.amzLink = res.data.amzLink;
      }).catch((e) => {
        this.loading = false;
      });
    },

    setLineResult (line, answer) {
      if (line.questionType === 'POINT') {
        let point = 1;
        switch (answer) {
          case '5 Stars' :
            point = 5;
            break;
          case '4 Stars' :
            point = 4;
            break;
          case '3 Stars' :
            point = 3;
            break;
          case '2 Stars' :
            point = 2;
            break;
          case '1 Star' :
            point = 1;
            break;
          default:
            break;
        }
        line.result = point;
      } else {
        if (answer === 'Yes') {
          line.result = 'Y';
        } else {
          line.result = 'N';
        }
      }
    },

    checkAnswer () {
      // wxkf问题和回答校验
      if (this.isWxkf) {
        if (this.isSingleQuestion) {
          for (let i = 0; i < this.allLines.length; i++) {
            let line = this.allLines[i];
            if (i === 0) {
              let answer = this.answerModel[i];
              if (!answer) {
                MessageBox.alert('Please complete the question', 'Tips', { type: 'error', confirmButtonText: 'Ok' });
                return true;
              }
              this.setLineResult(line, answer);
            } else {
              if (line.questionType === 'POINT') {
                line.result = 5;
              } else {
                line.result = 'Y';
              }
            }
          }
        } else {
          for (let i = 0; i < this.allLines.length; i++) {
            let answer = this.answerModel[i];
            if (!answer) {
              MessageBox.alert('Please complete the question', 'Tips', { type: 'error', confirmButtonText: 'Ok' });
              return true;
            }
            let line = this.allLines[i];
            this.setLineResult(line, answer);
          }
        }
        this.lines = this.allLines;
        return false;
      } else {
        // ticket问题和回答校验
        for (let i = 0; i < this.lines.length; i++) {
          let line = this.lines[i];
          let answer = this.answerModel[i];
          if (!answer) {
            MessageBox.alert('Please complete the question', 'Tips', { type: 'error', confirmButtonText: 'Ok' });
            return true;
          }
          if (i === 0) {
            line.result = Number(answer);
            continue;
          }
          this.setLineResult(line, answer);
        }
        return false;
      }
    }

  }
};
</script>

<style>
.survey {
  user-select: none;
  margin-bottom: 24px;
}

.survey-header {
  margin: 0 0 24px 60px;
  font-size: 18px;
}

.survey-header>div {
  margin-bottom: 12px;
}

.survey-body .question-item {
  margin: 0 24px 0 24px;
  padding:  16px 0 32px 0;
  border-bottom:  1px solid #A7A9AC ;
}

.survey-body .question-num {
  font-size: 16px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #def6f8;
  margin-right: 12px;

}

.survey-body .question-title {
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
}

.survey-body .el-radio {
  display: block;
  margin: 16px 0 0 32px;
  color: #36444B !important;
}

.survey-body .el-radio__inner {
  border: 1px solid #4acbd6 !important;
}

.survey-body .el-radio__inner:hover {
  border-color: #4acbd6 !important;
}

.survey-body .el-radio__input.is-checked .el-radio__inner {
  border-color:#4acbd6 !important;
  background: #4acbd6 !important;
}

.survey-body .el-radio__input.is-checked+.el-radio__label {
  color: #4acbd6 !important;
}

.survey-body .suggestion {
  margin: 0 24px 0 24px;
  padding:  16px 0 16px 0;
}

.survey-body .suggestion-text {
  margin: 16px 0 0 32px;
  width: 97%;
}

.survey-body .el-textarea__inner:focus {
  border-color: #4acbd6 !important;
}

.survey-body .submit-btn,
.amz-link .submit-btn {
  float: right;
  margin-right: 24px;
  width: 180px;
  height: 36px;
  background: #4ACBD6;
  border-radius: 4px;
  font-size: 18px;
  color: #FFFFFF;
}
.survey-body .submit-btn:hover,
.amz-link .submit-btn:hover {
  background: #42B6C0;
  color: #FFFFFF;
}
.survey .msg {
  text-align: center;
  margin-top: 100px;
  font-size: 18px;
}
.survey .msg .msg-txt {
  margin-top: 24px;
}

.survey .amz-link {
  margin: 30px 0;
}
.survey .amz-link-title {
  margin-bottom: 30px;
}
.survey .amz-link-body {
  text-align: left;
  margin-bottom: 30px;
  margin-left: 115px;
}
.survey .amz-link-body .amz-link-item {
  margin-bottom: 8px;
}
.amz-link .submit-btn {
  float: none;
  margin-right: 0;
}

.amz-link .submit-btn a {
  color: #ffffff;
}

.survey-body .horizontal-radio-group {
  display: flex;
  flex-direction: row;
}

</style>
